import { useState } from 'react';

const GuessLaunchPrice = ({ variant = 'default' }) => {
  const [guess, setGuess] = useState(7999);

  const getReaction = (val) => {
    if (val <= 4000) return "Ha, we wish it were that cheap 😄";
    if (val <= 9000) return "Bold guess... maybe too bold 👀";
    if (val <= 18000) return "Hmm, could go either way 🤔";
    if (val <= 30000) return "You might be onto something 👀";
    if (val <= 42000) return "That's generous of you 😏";
    return "We'll take it, honestly 😅";
  };

  const isSmall = variant === 'small';

  return (
    <div className={`flex flex-col ${isSmall ? 'items-start' : 'items-center md:items-start'} my-4`}>
      <div className={`inline-flex items-center gap-2 bg-[#FDF3E2] border border-[#F5A62359] text-[#B07515] text-[10.5px] font-bold tracking-[0.8px] px-4 py-2 rounded-full mb-5 uppercase`}>
        🔒 Launching Soon
      </div>
      <div className={`text-[10px] font-bold text-muted-foreground tracking-[1.5px] mb-2.5 uppercase`}>
        Guess our launch price
      </div>
      <div className={`font-sora font-extrabold text-foreground tracking-tight mb-3.5 tabular-nums ${isSmall ? 'text-4xl' : 'text-5xl'}`}>
        ₹{guess.toLocaleString('en-IN')}
      </div>

      <input
        type="range"
        min="1000"
        max="50000"
        step="500"
        value={guess}
        onChange={(e) => setGuess(Number(e.target.value))}
        className="w-full max-w-[280px] h-1.5 rounded-full outline-none mb-3.5 appearance-none bg-[#ECF1EE]"
        style={{
          '--thumb-size': '18px',
        }}
      />
      <style dangerouslySetInnerHTML={{
        __html: `
          input[type=range]::-webkit-slider-thumb {
            -webkit-appearance: none;
            width: var(--thumb-size);
            height: var(--thumb-size);
            border-radius: 50%;
            background: #12A876;
            border: 3px solid #fff;
            box-shadow: 0 1px 4px rgba(16,22,28,0.25);
            cursor: pointer;
          }
          input[type=range]::-moz-range-thumb {
            width: var(--thumb-size);
            height: var(--thumb-size);
            border-radius: 50%;
            background: #12A876;
            border: 3px solid #fff;
            box-shadow: 0 1px 4px rgba(16,22,28,0.25);
            cursor: pointer;
          }
        `
      }} />
      <div className="text-[12.5px] text-muted-foreground font-bold min-h-[18px]">
        {getReaction(guess)}
      </div>
    </div>
  );
};

export default GuessLaunchPrice;
